var map = {
	"./demos/basic/index.ts": 96996,
	"./demos/bubble/index.ts": 21951,
	"./demos/custom/index.ts": 2845,
	"./demos/list/index.ts": 62100,
	"./demos/loading/index.ts": 1801,
	"./demos/media/index.ts": 31793,
	"./demos/size/index.ts": 14435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17855;